export const activeSection = (state) => state.activeSection
export const lang = (state) => state.lang
export const headerHeight = (state) => state.header